import { supabase } from './supabaseClient';

export const createStripePortalSession = async (user) => {
  try {
    // Fetch subscription data
    const { data: subscription, error: fetchError } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('user_id', user.id)
      .eq('status', 'active')
      .order('created_at', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (fetchError) throw fetchError;

    const customerId = subscription?.stripe_customer_id || 
                      subscription?.metadata?.customer;

    if (!customerId) {
      throw new Error('Customer ID not found. Please contact support.');
    }

    // Create portal session
    const { data, error } = await supabase.functions.invoke('create-portal-session', {
      body: { customerId }
    });

    if (error) throw error;
    if (!data?.url) throw new Error('No portal URL received');

    // Redirect to Stripe Customer Portal
    window.location.href = data.url;
    
    return { success: true };
  } catch (err) {
    console.error('Error creating portal session:', err);
    return { 
      success: false, 
      error: err.message || 'Failed to open customer portal. Please try again later.' 
    };
  }
};